// extracted by mini-css-extract-plugin
module.exports = {"container":"information-step-module__container___2cHoF","removeProject":"information-step-module__removeProject___1NaxQ"};